import { IsNotEmpty, IsString, IsUUID } from 'class-validator';

export class GetCompetencyOptionsDto {
  @IsUUID()
  @IsString()
  @IsNotEmpty()
  eventId: string;

  @IsUUID()
  @IsString()
  @IsNotEmpty()
  staffPositionId: string;
}
